document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var navToggle = document.getElementById('nav-toggle');
  var navMenu = document.getElementById('nav-menu');
  if (navToggle && navMenu) {
    navToggle.addEventListener('click', function () {
      navMenu.classList.toggle('is-open');
    });
  }

  // Dropdown toggles (e.g. "Series" menu)
  document.querySelectorAll('[data-dropdown-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var list = toggle.parentElement.querySelector('[data-dropdown-list]');
      if (list) {
        list.classList.toggle('is-open');
      }
    });
  });

  // Innovation accordion (home page)
  document.querySelectorAll('[data-innovation-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('[data-innovation-item]');
      if (item) {
        item.classList.toggle('is-open');
      }
    });
  });

  // Splide sliders (top sellers, apparel, podcast, testimonials)
  document.querySelectorAll('[data-slider]').forEach(function (slider) {
    var track = slider.querySelector('[data-slider-track]');
    var prev = slider.querySelector('[data-slider-prev]');
    var next = slider.querySelector('[data-slider-next]');
    if (!track) return;

    var scrollAmount = 320;

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });
});

/* ---------------------------------------------------------------
   Cart drawer

   Listeners are delegated from the document rather than bound to the
   buttons directly. The drawer's contents are re-rendered after an
   add-to-cart, which replaces those buttons — directly bound listeners
   would be destroyed with them and the close icon would stop working.

   Exposed as window.JCBCart so product sections can open it after adding.
--------------------------------------------------------------- */
(function () {
  function drawer() { return document.getElementById('cart-drawer'); }
  function overlay() { return document.querySelector('[data-cart-overlay]'); }

  function openCart() {
    var d = drawer(), o = overlay();
    if (d) {
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
    }
    if (o) o.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
  }

  function closeCart() {
    var d = drawer(), o = overlay();
    if (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    }
    if (o) o.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) {
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) {
      e.preventDefault();
      closeCart();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* Re-fetch the current page and swap in the freshly rendered cart markup.
     Using the server's own HTML keeps one source of truth for the drawer. */
  function refreshCart() {
    return fetch(window.location.href, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newCount = doc.querySelector('.cart-quantity');
        var oldCount = document.querySelector('.cart-quantity');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;

        var newDrawer = doc.querySelector('#cart-drawer');
        var oldDrawer = drawer();
        if (newDrawer && oldDrawer) oldDrawer.innerHTML = newDrawer.innerHTML;
      })
      .catch(function () { /* falls back to a normal reload on the next click */ });
  }

  /* Quantity steppers and remove, from inside the drawer.

     One handler covers both: each control carries the line it refers to and
     the quantity it should become (remove is simply quantity 0). Falls back
     to reading the link's own href, so it also works against a cached copy
     of the older drawer markup. Delegated, so it survives re-renders. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-change], [data-cart-remove], .cart-drawer__remove');
    if (!link) return;

    var payload = null;
    var d = link.dataset || {};

    if (d.line && typeof d.quantity !== 'undefined') {
      payload = { line: Number(d.line), quantity: Number(d.quantity) };
    } else if (d.line) {
      payload = { line: Number(d.line), quantity: 0 };
    } else if (link.href) {
      var params = new URL(link.href, window.location.origin).searchParams;
      var qty = params.get('quantity');
      if (params.get('line')) {
        payload = { line: Number(params.get('line')), quantity: qty === null ? 0 : Number(qty) };
      } else if (params.get('id')) {
        // Older markup uses ?id=<variant>:<key>
        payload = { id: params.get('id'), quantity: qty === null ? 0 : Number(qty) };
      }
    }

    // Nothing usable — let the link behave normally.
    if (!payload) return;
    if (payload.quantity < 0) payload.quantity = 0;

    e.preventDefault();

    var el = drawer();
    if (el) el.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Could not update cart');
        return refreshCart();
      })
      .then(function () {
        var after = drawer();
        if (after) after.classList.remove('is-updating');
      })
      .catch(function () { window.location.href = link.href; });
  });

  window.JCBCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
